import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { Chart } from 'angular-highcharts';
import dayjs from 'dayjs/esm';
import * as moment from 'moment';
import { CommonService, SiteService } from 'src/app/services/index';
import {
  Constants,
  DateService,
  Highcharts$,
  WarningDialog
} from 'src/app/shared/index';
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@Component({
  selector: 'app-sensor-trend-modal',
  templateUrl: './sensor-trend-modal.component.html',
  styleUrls: ['./sensor-trend-modal.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class SensorTrendModalComponent implements OnInit {
  formData: UntypedFormGroup;
  humidChart: Chart;
  temperatorChart: Chart;

  startDate = new UntypedFormControl(moment());
  endDate = new UntypedFormControl(moment());
  entityName: string;
  selectedSensorData: any;
  sensorData: any;
  selectDateRange: any;
  ranges = {
    Yesterday: [
      this.dateService.subDay(new Date(), 1),
      this.dateService.subDay(new Date(), 1)
    ],
    'Last 7 days': [this.dateService.subDay(new Date(), 7), new Date()]
    //'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
    //'This month': [moment().startOf('month'), moment().endOf('month')]
  };
  colors = ['#234463', '#597D95', '#B5C9D2', '#EA0027'];
  constructor(
    private dialogRef: MatDialogRef<SensorTrendModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private commonService: CommonService,
    public dialog: MatDialog,
    private dateService: DateService,
    private siteService: SiteService
  ) {
    this.entityName = data.nodeName;
    this.sensorData = data.sensorDataList;
    if (this.sensorData.length === 1) {
      this.selectedSensorData = this.sensorData[0].sensorRId;
    }
  }

  ngOnInit() {}

  onGenerate() {
    this.generateChart();
  }
  onClean() {
    const sensorTrendsContainerEl = document.querySelector(
      '#SensorTrendsContainer'
    );
    sensorTrendsContainerEl.innerHTML = '';
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
  generateChart() {
    const fromDate = moment(
      this.selectDateRange.startDate
        ? this.selectDateRange.startDate.valueOf()
        : ''
    )
      .startOf('day')
      .format('YYYY-MM-DD');

    const toDate = moment(
      this.selectDateRange.endDate ? this.selectDateRange.endDate.valueOf() : ''
    )
      .endOf('day')
      .format('YYYY-MM-DD');

    const sensorTrendParams = {
      nodeId: this.data.nodeId,
      NodeName: this.data.nodeName,
      siteID: this.data.siteId,
      startDate: fromDate,
      endDate: toDate,
      selectedSensor: this.selectedSensorData
    };
    if (
      dayjs(this.selectDateRange.endDate).diff(
        dayjs(this.selectDateRange.startDate),
        'days'
      ) > 9
    ) {
      this.onOpenAlertBox(
        'Note: Data display limited to 10 days. Please select duration not more than 10 days'
      );
    } else {
      this.siteService
        .getSensorTrendForGadgets(sensorTrendParams)
        .subscribe((data) => {
          if (data) {
            this.drawSensorTrends(data);
          }
        });
    }
  }

  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  };

  transformDate(date: UntypedFormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  formatDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }

  private processSeriesData(dataset, i: any) {
    const seriesData = [];
    // Series data
    if (dataset.outputType === Constants.HYDRAULIC_OUTPUT_TYPE.Switch) {
      seriesData.push({
        data: dataset.y.map((obj) => {
          if (obj === dataset.di_0) {
            return 0;
          } else if (obj === dataset.di_1) {
            return 1;
          }
        }),
        name: dataset.title,
        yAxis: 0,
        type: 'areaspline',
        color: '#5CB85C',
        zones: [
          {
            value: dataset.lowerThreshold,
            color: '#C1C2C4'
          },
          {
            value: dataset.upperThreshold,
            color: 'rgb(51,204,51)'
          },
          {
            color: '#C1C2C4'
          }
        ]
      });
    } else if (dataset.parameterType !== 'Cleanliness') {
      seriesData.push({
        data:
          dataset.kpiName === 'Air'
            ? dataset.y.map((ele) => ele / 60)
            : dataset.y.map(Number),
        name: dataset.title,
        yAxis: 0,
        type: 'areaspline',
        color: '#5CB85C',
        zones: [
          {
            value: dataset.lowerThreshold,
            color: '#C1C2C4'
          },
          {
            value: dataset.upperThreshold,
            color: 'rgb(51,204,51)'
          },
          {
            color: '#C1C2C4'
          }
        ]
      });
    } else {
      // OPM Series data
      const chartType = 'line';

      seriesData.push({
        data: dataset.y.map(Number),
        name: dataset.title,
        type: chartType,
        color: this.colors[i % 4]
      });
    }

    return seriesData;
  }

  drawSensorTrends(data) {
    const sensorTrendsContainerEl = document.querySelector(
      '#SensorTrendsContainer'
    );
    sensorTrendsContainerEl.innerHTML = '';
    data.forEach((dataset, i) => {
      let seriesData = [];
      let showlegend = true;
      let yAxisTitle;
      let plotLinesArray = [];
      let valveStausCategories = [];
      let subTitleText = '';
      // Series data
      seriesData = this.processSeriesData(dataset, i);
      if (dataset.kpiName === 'Air') {
        dataset.unit = 'm³/hour';
        dataset.y = dataset.y.map((ele) => ele / 60);
      }

      // Handling y-axis title and legend
      if (dataset != null && dataset.x.length > 0) {
        showlegend = true;
        valveStausCategories = [];

        // OutType of SWITCh should have CATEGORIES
        if (dataset.outputType === Constants.HYDRAULIC_OUTPUT_TYPE.Switch) {
          subTitleText = '';
          valveStausCategories = [];
          valveStausCategories.push(dataset.di_0);
          valveStausCategories.push(dataset.di_1);
          plotLinesArray = [];
        } else {
          // OPM
          // Threshold NOT required
          // const parameterUnit = dataset.unit != null ? dataset.unit : '';
          subTitleText = '';
          plotLinesArray = [];
        }
        // else {
        //   const parameterUnit = dataset.unit != null ? dataset.unit : '';
        //   subTitleText =
        //     'Threshold  Value: ' +
        //     dataset.lowerThreshold +
        //     ' ' +
        //     dataset.unit +
        //     ' to ' +
        //     ' ' +
        //     dataset.upperThreshold +
        //     ' ' +
        //     dataset.unit +
        //     '<br/>';
        //   plotLinesArray.push(
        //     {
        //       color: 'red',
        //       width: 3,
        //       value: dataset.lowerThreshold,
        //       label: {
        //         text: 'Lower Threshold'
        //       }
        //     },
        //     {
        //       color: 'red',
        //       width: 3,
        //       value: dataset.upperThreshold,
        //       label: {
        //         text: 'Upper Threshold'
        //       }
        //     }
        //   );
        // }
        yAxisTitle = dataset.parameterTypeDisplayValue;
      } else {
        subTitleText =
          ' ' + '<br/>' + 'No Data Present for selected Date... !!!!' + '<br/>';
        yAxisTitle = '';
        showlegend = false;
      }

      // Container and Div
      const divClass = document.createElement('div');
      divClass.setAttribute('class', 'Sensor_TrendsChart');
      divClass.setAttribute('id', dataset.title);

      // Highcharts
      let opts: any;
      opts = {
        chart: {
          zoomType: 'x',
          spacingTop: 5,
          spacingBottom: 20
        },
        title: {
          text: dataset.title,
          align: 'left',
          margin: 20,
          x: 75,
          style: {
            fontWeight: 'bold',
            fontSize: '20px'
          }
        },
        subtitle: {
          align: 'left',
          margin: 20,
          x: 75,
          text: subTitleText,
          style: {
            fontSize: '15px'
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: showlegend
        },
        xAxis: {
          crosshair: true,
          title: {
            text: 'Date & Time',
            style: {
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          type: 'datetime',
          labels: {
            formatter: function () {
              return Highcharts$.dateFormat('%b %e, %Y %H:%M', this.value);
            },
            style: {
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          categories: dataset.x,
          tickInterval: dataset.x.length / 6
        },
        navigation: {
          buttonOptions: {
            enabled: true
          }
        },
        yAxis: [
          {
            lineWidth: 1,
            title: {
              text: yAxisTitle !== '' ? yAxisTitle : dataset.unit,
              style: {
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            // min: 0,
            labels: {
              formatter: function () {
                if (isNaN(this.value)) {
                  return this.value;
                } else {
                  return Highcharts$.numberFormat(
                    this.value,
                    Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
                    '.',
                    ','
                  );
                }
              },
              style: {
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            categories: valveStausCategories,
            plotLines: plotLinesArray
          }
        ],
        plotOptions: {
          series: {
            marker: {
              enabled: true
            },
            fillOpacity: 0.3,
            type: 'spline',
            turboThreshold: 0,
            threshold: null,
            animation: {
              //                                 duration: $scope.ST_TrendsChart_Animation_Duration
            },
            point: {}
          }
          // DataLabels above Column (OPM)
          //                       column: {
          //                           dataLabels: {
          //                               enabled: true
          //                           }
          //                       }
        },
        tooltip: {
          // shared: true,
          crosshairs: true,
          formatter: function () {
            // 'EEEE, MMM d, h:mm:ss'
            let toolTipData =
              '<font style="font-size: 10px;">' +
              dayjs(this.x).format(
                Constants.MOMENT_DATE_FORMAT.FULL_DATE_TIME_FORMAT
              ) +
              '</font>';
            let suffix;
            if (dataset.outputType === Constants.HYDRAULIC_OUTPUT_TYPE.Switch) {
              suffix = valveStausCategories[this.y];
            } else {
              suffix =
                Highcharts$.numberFormat(
                  this.y,
                  Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
                  '.',
                  ','
                ) +
                ' ' +
                dataset.unit +
                ' <br>';
            }
            toolTipData +=
              '<br><span style="color: ' +
              this.series.color +
              '">\u25CF</span>' +
              this.series.name +
              ': ' +
              suffix;

            return '<b>' + toolTipData + '</b>';
          }
        },
        series: seriesData
      };
      sensorTrendsContainerEl.appendChild(divClass);
      Highcharts$.chart(divClass, opts);
    });
  }
  onChangeDateRange() {
    if (
      this.commonService.isLaterThanCurentDate(this.selectDateRange.endDate)
    ) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
  }
}
